/**
 * CheckoutPromoCode Component
 */

import { requestAddPromoCode } from '../../../redux/actions/checkout';
import { getBillingAddress } from '../../../redux/form/selectors';
import { FieldUppercase } from '../../../redux/form/utils';

import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { connect } from 'react-redux';
import { FormProps, reduxForm, SubmissionError } from 'redux-form';

import Button from '../../atoms/buttons/Button';
import TextField from '../../atoms/forms/TextField';

interface IFormFields {
  code: string;
}

interface IOwnStateProps {
  billingAddress: IAddress;
}

type CheckoutPromoCodeProps = IOwnStateProps & FormProps<IFormFields, any, any>;

const classes = new BEM('checkout__promo-code');

class CheckoutPromoCode extends React.Component<CheckoutPromoCodeProps, {}> {

  render() {
    const {
      handleSubmit,
      submitting,
    } = this.props;
    return (
      <form onSubmit={handleSubmit} {...classes() }>
        <FieldUppercase
          component={TextField}
          name="code"
          colorScheme="transparent"
          inlineButton={<Button label="Apply" colorScheme="dark" isSubmit />}
          placeholder="Got a promo code?"
          size="large"
          disabled={submitting}
        />
      </form>
    );
  }
}

const CheckoutPromoCodeForm = reduxForm<IFormFields, CheckoutPromoCodeProps, any>({
  form: 'checkout-promo-code',
  onSubmit: ({ code }, dispatch, { billingAddress }) => new Promise((resolve, reject) => {
    dispatch(requestAddPromoCode({
      code,
      country_code: billingAddress ? billingAddress.country : undefined,
      promise: { resolve, reject },
      subdivision_code: billingAddress ? billingAddress.state : undefined,
    }));
  }).then((err) => {
    if (err) {
      throw new SubmissionError({ code: 'The entered code is not valid.' });
    }
  }).catch((err) => {
    throw new SubmissionError({ code: 'The entered code is not valid.' });
  }),
  onSubmitSuccess: (res, dispatch, { reset }) => {
    reset!();
  },
})(CheckoutPromoCode);

const ConnectedCheckoutPromoCodeForm = connect(
  (state: IStoreState): IOwnStateProps => ({
    billingAddress: getBillingAddress(state),
  }),
)(CheckoutPromoCodeForm);

export default ConnectedCheckoutPromoCodeForm;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/pages/Checkout/CheckoutPromoCode.tsx